import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';

const SettingsPage = () => {
  const [activeSection, setActiveSection] = useState('general');
  const [activeReminderTab, setActiveReminderTab] = useState('7_days'); // Gün hatırlatması sekmesi
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [settings, setSettings] = useState({
    // Genel Ayarlar
    main_slug: 'fbajans',
    company_name: 'FBAJANS Panel',
    company_logo: '',
    
    // Sistem Mesajları
    forgot_password_message: `🔐 FBAJANS Panel - Yeni Şifreniz

Kullanıcı Adı: {username}
Yeni Şifre: {password}

Güvenliğiniz için ilk girişte şifrenizi değiştirmeniz önerilir.

FBAJANS Panel Ekibi`,
    
    application_received_message: `🎉 Başvurunuz Alındı!

Merhaba {firma},

Başvurunuz başarıyla alınmıştır. En kısa sürede değerlendirilecektir.

Kullanıcı Adınız: {kullanici-adi}

FBAJANS Panel Ekibi`,
    
    application_approved_message: `✅ Başvurunuz Onaylandı!
    
Merhaba {firma},
    
Başvurunuz onaylanmıştır! Artık panel özelliklerini kullanmaya başlayabilirsiniz.
    
Kullanıcı Adınız: {kullanici-adi}
Başvuru Tarihi: {basvuru-tarihi}
    
Panel girişi için: https://panel.fbajans.com
    
FBAJANS Panel Ekibi`,
    
    // Gün Hatırlatması Mesajları
    license_reminder_7_days: '',
    license_reminder_3_days: '',
    license_reminder_0_days: '',
    
    // Güvenlik Ayarları
    session_timeout: 3600,
    max_login_attempts: 5,
    password_min_length: 6,
    
    // Üyelik Sözleşmesi ve Gizlilik Politikası
    membership_agreement_message: '',
    privacy_policy_message: ''
  });

  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoUploading, setLogoUploading] = useState(false);

  const MOBILE_BREAKPOINT = 1200;

  useEffect(() => {
    // Tarayıcı title'ını ayarla
    document.title = 'FBAJANS WhatsApp Business - Ayarlar';
    
    // Check if mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);

    // Sayfa ilk açıldığında ayarları backend'den yükle
    loadSettings();

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Notification auto-hide
  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        setNotification(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const loadSettings = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/admin/settings');
      const data = await response.json();
      if (data.success) {
        console.log('🔍 Backend\'den gelen settings:', data.data);
        console.log('🔍 Logo file:', data.data.logo_file);
        console.log('🔍 Company logo:', data.data.company_logo);
        // Backend'den gelen ayarları merge et, ama boş/undefined değerleri frontend'teki mevcut değerlerle değiştirme
        setSettings(prev => {
          const merged = { ...prev };
          // Sadece backend'de gerçekten bir değer varsa (null/undefined/boş değilse) kullan
          Object.keys(data.data).forEach(key => {
            // Özellikle gün hatırlatması mesajları için: backend'de boş/null ise frontend'teki boş değeri koru
            if (key.startsWith('license_reminder_')) {
              if (data.data[key] && data.data[key].trim() !== '') {
                merged[key] = data.data[key];
              } else {
                // Backend'de boş/null ise, frontend'teki boş değeri koru (varsayılan mesaj gelmesin)
                merged[key] = prev[key] || '';
              }
            } else {
              // Diğer ayarlar için normal merge
              if (data.data[key] !== null && data.data[key] !== undefined) {
                merged[key] = data.data[key];
              }
            }
          });
          return merged;
        });
      }
    } catch (error) {
      console.error('Ayar yükleme hatası:', error);
    }
    setLoading(false);
  };

  const saveSettings = async (section) => {
    setLoading(true);
    try {
      const response = await fetch('/api/admin/settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (data.success) {
        setNotification({
          type: 'success',
          message: 'Ayarlar başarıyla kaydedildi!'
        });
        // Ayarları yeniden yükle
        loadSettings();
      } else {
        setNotification({
          type: 'error',
          message: data.message || 'Ayarlar kaydedilirken hata oluştu'
        });
      }
    } catch (error) {
      console.error('Ayar kaydetme hatası:', error);
      setNotification({
        type: 'error',
        message: 'Sunucu hatası'
      });
    }
    setLoading(false);
  };

  const handleLogoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    // Dosya tipini kontrol et
    if (!file.type.startsWith('image/')) {
      setNotification({
        type: 'error',
        message: 'Lütfen sadece resim dosyası seçin'
      });
      return;
    }
    
    setLogoFile(file);
    
    // Preview oluştur
    const reader = new FileReader();
    reader.onload = (e) => {
      setLogoPreview(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const uploadLogo = async () => {
    if (!logoFile) return;
    
    setLogoUploading(true);
    
    try {
      const formData = new FormData();
      formData.append('logo', logoFile);
      
      // Yeni backend endpoint'ini kullan
      const response = await fetch('/api/admin/upload-logo', {
        method: 'POST',
        body: formData
      });
      
      const data = await response.json();
      
      if (data.success) {
        setNotification({
          type: 'success',
          message: data.message
        });
        
        // Settings'i yenile
        loadSettings();
        
        // Preview'i temizle
        setLogoFile(null);
        setLogoPreview(null);
        
        // File input'u temizle
        const fileInput = document.getElementById('logo-upload');
        if (fileInput) fileInput.value = '';
        
      } else {
        throw new Error(data.message || 'Logo yükleme başarısız');
      }
    } catch (error) {
      setNotification({
        type: 'error',
        message: error.message || 'Logo yükleme hatası'
      });
    } finally {
      setLogoUploading(false);
    }
  };

  const resetToDefaults = async () => {
    if (!window.confirm('Tüm ayarları varsayılan değerlere sıfırlamak istediğinizden emin misiniz?')) return;
    
    setLoading(true);
    try {
      const response = await fetch('http://localhost/panel.fbajans.com/api/settings/reset_settings.php', {
        method: 'POST'
      });
      const data = await response.json();
      if (data.status === 'success') {
        loadSettings();
        setNotification({
          type: 'success',
          message: 'Ayarlar varsayılan değerlere sıfırlandı!'
        });
      }
    } catch (error) {
      console.error('Ayar sıfırlama hatası:', error);
      setNotification({
        type: 'error',
        message: 'Ayarlar sıfırlanırken hata oluştu'
      });
    }
    setLoading(false);
  };

  const sections = [
    { id: 'general', name: 'Genel Ayarlar', icon: 'fas fa-building' },
    { id: 'messages', name: 'Sistem Mesajları', icon: 'fas fa-comments' },
    { id: 'security', name: 'Güvenlik Ayarları', icon: 'fas fa-shield-alt' }
  ];

  return (
    <AdminLayout>
      <div style={{ padding: '20px', overflowX: 'hidden' }}>
        {/* Notification */}
        {notification && (
          <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            padding: '15px 20px',
            background: notification.type === 'success' ? '#d4edda' : '#f8d7da',
            color: notification.type === 'success' ? '#155724' : '#721c24',
            border: `1px solid ${notification.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            zIndex: 1000,
            maxWidth: '400px'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>{notification.message}</span>
              <button
                onClick={() => setNotification(null)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '18px',
                  cursor: 'pointer',
                  marginLeft: '10px'
                }}
              >
                ×
              </button>
            </div>
          </div>
        )}
        
        {/* Standart Header */}
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '30px',
          marginBottom: '30px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          border: '1px solid #e2e8f0'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '20px' : '0'
          }}>
            <div>
              <h1 style={{ 
                margin: '0 0 5px', 
                fontSize: isMobile ? '24px' : '32px', 
                fontWeight: '700',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                FBAJANS WhatsApp Business
              </h1>
              <p style={{ 
                margin: '0 0 5px', 
                fontSize: isMobile ? '16px' : '18px',
                fontWeight: '500',
                color: '#555'
              }}>
                <i className="fas fa-cog" style={{ marginRight: '8px' }}></i>
                Ayarlar
              </p>
            </div>
            <div style={{
              display: 'flex',
              gap: '15px',
              flexWrap: 'wrap',
              justifyContent: isMobile ? 'center' : 'flex-end'
            }}>
              <button
                onClick={resetToDefaults}
                style={{
                  padding: '12px 20px',
                  background: '#dc3545',
                  border: 'none',
                  borderRadius: '10px',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 5px 15px rgba(220, 53, 69, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <i className="fas fa-undo" style={{ marginRight: '8px' }}></i>
                Varsayılana Sıfırla
              </button>
            </div>
          </div>
        </div>

        <div style={{ 
          display: 'flex', 
          gap: '20px', 
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch'
        }}>
          {/* Sol Menü */}
          <div style={{
            width: isMobile ? '100%' : '250px',
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            padding: '20px',
            boxSizing: 'border-box'
          }}>
            <h3 style={{ marginTop: 0, marginBottom: '15px', color: '#333' }}>Ayar Kategorileri</h3>
            {sections.map(section => (
              <button
                key={section.id}
                onClick={() => setActiveSection(section.id)}
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  background: activeSection === section.id ? '#007bff' : 'transparent',
                  color: activeSection === section.id ? 'white' : '#333',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  textAlign: 'left',
                  marginBottom: '8px',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <i className={section.icon} style={{ marginRight: '8px' }}></i>
                {section.name}
              </button>
            ))}
          </div>

          {/* Sağ İçerik */}
          <div style={{
            flex: 1,
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            padding: isMobile ? '20px' : '30px',
            boxSizing: 'border-box'
          }}>
            {loading && (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
              Yükleniyor...
              </div>
            )}

            {/* Genel Ayarlar */}
            {activeSection === 'general' && (
              <div>
                <h2 style={{ marginTop: 0, marginBottom: '20px' }}>
                  <i className="fas fa-building" style={{ marginRight: '8px' }}></i>
                  Genel Ayarlar
                </h2>
                
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                    Ana Slug
                  </label>
                  <input
                    type="text"
                    value={settings.main_slug}
                    onChange={(e) => setSettings(prev => ({ ...prev, main_slug: e.target.value }))}
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      boxSizing: 'border-box'
                    }}
                  />
                  <small style={{ color: '#666' }}>WhatsApp servisinde kullanılacak ana firma slug'ı</small>
                </div>

                <div className="form-group">
                  <label>📷 Logo Yönetimi</label>
                  
                  {/* Logo Upload */}
                  <div style={{ marginBottom: '15px' }}>
                    <input
                      id="logo-upload"
                      type="file"
                      accept="image/*"
                      onChange={handleLogoUpload}
                      style={{ marginBottom: '10px' }}
                    />
                    
                    {logoPreview && (
                      <div style={{ marginBottom: '10px' }}>
                        <p style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px' }}>Yeni Logo Önizleme:</p>
                        <div style={{
                          border: '2px solid #ff69b4',
                          borderRadius: '8px',
                          padding: '15px',
                          background: '#fff',
                          textAlign: 'center',
                          maxWidth: '200px'
                        }}>
                          <img 
                            src={logoPreview} 
                            alt="Logo Önizleme" 
                            style={{ 
                              maxWidth: '100%', 
                              height: 'auto',
                              marginBottom: '10px'
                            }} 
                          />
                          <div style={{ 
                            fontSize: '12px', 
                            color: '#666'
                          }}>
                            {settings.logo_message || 'FBAJANS İLE KOLAY E-TİCARET'}
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Mevcut Logo Önizleme */}
                    {!logoPreview && (
                      <div style={{ marginBottom: '15px' }}>
                        <p style={{ margin: '0 0 10px 0', color: '#666', fontSize: '14px' }}>Mevcut Logo:</p>
                        <div style={{
                          border: '2px solid #ff69b4',
                          borderRadius: '8px',
                          padding: '15px',
                          background: '#fff',
                          textAlign: 'center',
                          maxWidth: '200px'
                        }}>
                          {settings.logo_file ? (
                            <img 
                              src={`https://panel.fbajans.com/api/logo/${settings.logo_file}`} 
                              alt="Mevcut Logo" 
                              style={{ 
                                maxWidth: '100%', 
                                height: 'auto',
                                marginBottom: '10px'
                              }} 
                            />
                          ) : (
                            <img 
                              src="/logo.png" 
                              alt="Varsayılan Logo" 
                              style={{ 
                                maxWidth: '100%', 
                                height: 'auto',
                                marginBottom: '10px'
                              }} 
                            />
                          )}
                        </div>
                      </div>
                    )}
                    
                    {logoFile && (
                      <button
                        type="button"
                        onClick={uploadLogo}
                        disabled={logoUploading}
                        style={{
                          padding: '8px 16px',
                          background: logoUploading ? '#6c757d' : '#28a745',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: logoUploading ? 'not-allowed' : 'pointer'
                        }}
                      >
                        {logoUploading ? (
                          <>
                            <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                            Yükleniyor...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-upload" style={{ marginRight: '8px' }}></i>
                            Logo Yükle
                          </>
                        )}
                      </button>
                    )}
                  </div>
                  
                  <small style={{ color: '#666' }}>
                    Desteklenen formatlar: JPG, PNG, GIF, WebP (Otomatik boyutlandırılır: 200x100px)
                  </small>
                </div>

                <button
                  onClick={() => saveSettings('general')}
                  disabled={loading}
                  style={{
                    padding: '12px 24px',
                    background: '#28a745',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    fontSize: '14px'
                  }}
                >
                  <i className="fas fa-save" style={{ marginRight: '8px' }}></i>
                  Genel Ayarları Kaydet
                </button>
              </div>
            )}

            {/* Sistem Mesajları */}
            {activeSection === 'messages' && (
              <div>
                <h2 style={{ marginTop: 0, marginBottom: '20px' }}>
                  <i className="fas fa-comments" style={{ marginRight: '8px' }}></i>
                  Sistem Mesajları
                </h2>
                
                {/* Ana Mesajlar */}
                <div style={{ marginBottom: '30px' }}>
                  <h3 style={{ marginBottom: '15px', color: '#333', fontSize: '18px' }}>
                    <i className="fas fa-envelope" style={{ marginRight: '8px' }}></i>
                    Temel Mesajlar
                  </h3>
                  
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                      Hizmet Sözleşmesi Mesajı
                    </label>
                    <textarea
                      value={settings.membership_agreement_message || ''}
                      onChange={(e) => setSettings(prev => ({ ...prev, membership_agreement_message: e.target.value }))}
                      rows={15}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        boxSizing: 'border-box',
                        fontFamily: 'monospace',
                        fontSize: '13px',
                        lineHeight: '1.4'
                      }}
                      placeholder="Hizmet sözleşmesi mesajı..."
                    />
                    <small style={{ color: '#666' }}>
                      Kayıt sırasında gösterilecek hizmet sözleşmesi metni
                    </small>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                      Gizlilik Politikası Mesajı
                    </label>
                    <textarea
                      value={settings.privacy_policy_message || ''}
                      onChange={(e) => setSettings(prev => ({ ...prev, privacy_policy_message: e.target.value }))}
                      rows={15}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        boxSizing: 'border-box',
                        fontFamily: 'monospace',
                        fontSize: '13px',
                        lineHeight: '1.4'
                      }}
                      placeholder="Gizlilik politikası mesajı..."
                    />
                    <small style={{ color: '#666' }}>
                      Kayıt sırasında gösterilecek gizlilik politikası metni
                    </small>
                  </div>
                  
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                      Başvuru Alındı Mesajı
                    </label>
                    <textarea
                      value={settings.application_received_message}
                      onChange={(e) => setSettings(prev => ({ ...prev, application_received_message: e.target.value }))}
                      rows={8}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        boxSizing: 'border-box',
                        fontFamily: 'monospace',
                        fontSize: '13px',
                        lineHeight: '1.4'
                      }}
                      placeholder="Başvuru alındığında gönderilecek mesaj..."
                    />
                    <small style={{ color: '#666' }}>
                      Kullanılabilir değişkenler: {'{firma}'}, {'{kullanici-adi}'}
                    </small>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                      Başvuru Onay Mesajı
                    </label>
                    <textarea
                      value={settings.application_approved_message}
                      onChange={(e) => setSettings(prev => ({ ...prev, application_approved_message: e.target.value }))}
                      rows={8}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        boxSizing: 'border-box',
                        fontFamily: 'monospace',
                        fontSize: '13px',
                        lineHeight: '1.4'
                      }}
                      placeholder="Başvuru onaylandığında gönderilecek mesaj..."
                    />
                    <small style={{ color: '#666' }}>
                      Kullanılabilir değişkenler: {'{firma}'}, {'{kullanici-adi}'}, {'{basvuru-tarihi}'}, {'{baslama-tarihi}'}, {'{bitis-tarihi}'}
                    </small>
                  </div>

                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                      Şifre Sıfırlama Mesajı
                    </label>
                    <textarea
                      value={settings.forgot_password_message}
                      onChange={(e) => setSettings(prev => ({ ...prev, forgot_password_message: e.target.value }))}
                      rows={8}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        boxSizing: 'border-box',
                        fontFamily: 'monospace',
                        fontSize: '13px',
                        lineHeight: '1.4'
                      }}
                    />
                    <small style={{ color: '#666' }}>
                      Kullanılabilir değişkenler: {'{username}'}, {'{password}'}
                    </small>
                  </div>
                </div>

                {/* Gün Hatırlatması Mesajları */}
                <div style={{ marginBottom: '30px', borderTop: '2px solid #e2e8f0', paddingTop: '30px' }}>
                  <h3 style={{ marginBottom: '20px', color: '#333', fontSize: '18px' }}>
                    <i className="fas fa-bell" style={{ marginRight: '8px' }}></i>
                    Lisans Gün Hatırlatmaları
                  </h3>
                  
                  {/* Sekmeler */}
                  <div style={{ 
                    display: 'flex', 
                    gap: '10px', 
                    marginBottom: '20px',
                    borderBottom: '2px solid #e2e8f0'
                  }}>
                    <button
                      onClick={() => setActiveReminderTab('7_days')}
                      style={{
                        padding: '12px 20px',
                        background: activeReminderTab === '7_days' ? '#007bff' : 'transparent',
                        color: activeReminderTab === '7_days' ? 'white' : '#333',
                        border: 'none',
                        borderBottom: activeReminderTab === '7_days' ? '3px solid #007bff' : '3px solid transparent',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '6px 6px 0 0',
                        transition: 'all 0.3s'
                      }}
                    >
                      📅 7 Gün Kala
                    </button>
                    <button
                      onClick={() => setActiveReminderTab('3_days')}
                      style={{
                        padding: '12px 20px',
                        background: activeReminderTab === '3_days' ? '#ffc107' : 'transparent',
                        color: activeReminderTab === '3_days' ? 'white' : '#333',
                        border: 'none',
                        borderBottom: activeReminderTab === '3_days' ? '3px solid #ffc107' : '3px solid transparent',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '6px 6px 0 0',
                        transition: 'all 0.3s'
                      }}
                    >
                      ⚠️ 3 Gün Kala
                    </button>
                    <button
                      onClick={() => setActiveReminderTab('0_days')}
                      style={{
                        padding: '12px 20px',
                        background: activeReminderTab === '0_days' ? '#dc3545' : 'transparent',
                        color: activeReminderTab === '0_days' ? 'white' : '#333',
                        border: 'none',
                        borderBottom: activeReminderTab === '0_days' ? '3px solid #dc3545' : '3px solid transparent',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600',
                        borderRadius: '6px 6px 0 0',
                        transition: 'all 0.3s'
                      }}
                    >
                      🔴 0 Gün (Süresi Doldu)
                    </button>
                  </div>

                  {/* İçerik Alanları */}
                  <div style={{ 
                    background: '#f8f9fa', 
                    padding: '20px', 
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0'
                  }}>
                    {activeReminderTab === '7_days' && (
                      <div>
                        <div style={{ 
                          marginBottom: '15px', 
                          padding: '12px', 
                          background: '#e3f2fd', 
                          borderRadius: '6px',
                          border: '1px solid #90caf9'
                        }}>
                          <strong style={{ color: '#1976d2' }}>ℹ️ Bilgi:</strong>
                          <p style={{ margin: '8px 0 0', color: '#1565c0', fontSize: '14px' }}>
                            Lisans bitiş tarihinden 7 gün önce bu mesaj gönderilir.
                          </p>
                        </div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                          7 Gün Kala Hatırlatma Mesajı
                        </label>
                        <textarea
                          value={settings.license_reminder_7_days || ''}
                          onChange={(e) => setSettings(prev => ({ ...prev, license_reminder_7_days: e.target.value }))}
                          rows={10}
                          style={{
                            width: '100%',
                            padding: '12px',
                            border: '2px solid #007bff',
                            borderRadius: '6px',
                            boxSizing: 'border-box',
                            fontFamily: 'monospace',
                            fontSize: '13px',
                            lineHeight: '1.4'
                          }}
                          placeholder="7 gün kala gönderilecek mesaj..."
                        />
                        <small style={{ color: '#666', display: 'block', marginTop: '8px' }}>
                          <strong>Kullanılabilir değişkenler:</strong> {'{firma}'}, {'{kullanici-adi}'}, {'{baslama-tarihi}'}, {'{bitis-tarihi}'}
                        </small>
                      </div>
                    )}

                    {activeReminderTab === '3_days' && (
                      <div>
                        <div style={{ 
                          marginBottom: '15px', 
                          padding: '12px', 
                          background: '#fff3cd', 
                          borderRadius: '6px',
                          border: '1px solid #ffc107'
                        }}>
                          <strong style={{ color: '#856404' }}>⚠️ Uyarı:</strong>
                          <p style={{ margin: '8px 0 0', color: '#856404', fontSize: '14px' }}>
                            Lisans bitiş tarihinden 3 gün önce bu mesaj gönderilir.
                          </p>
                        </div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                          3 Gün Kala Uyarı Mesajı
                        </label>
                        <textarea
                          value={settings.license_reminder_3_days || ''}
                          onChange={(e) => setSettings(prev => ({ ...prev, license_reminder_3_days: e.target.value }))}
                          rows={10}
                          style={{
                            width: '100%',
                            padding: '12px',
                            border: '2px solid #ffc107',
                            borderRadius: '6px',
                            boxSizing: 'border-box',
                            fontFamily: 'monospace',
                            fontSize: '13px',
                            lineHeight: '1.4'
                          }}
                          placeholder="3 gün kala gönderilecek mesaj..."
                        />
                        <small style={{ color: '#666', display: 'block', marginTop: '8px' }}>
                          <strong>Kullanılabilir değişkenler:</strong> {'{firma}'}, {'{kullanici-adi}'}, {'{baslama-tarihi}'}, {'{bitis-tarihi}'}
                        </small>
                      </div>
                    )}

                    {activeReminderTab === '0_days' && (
                      <div>
                        <div style={{ 
                          marginBottom: '15px', 
                          padding: '12px', 
                          background: '#f8d7da', 
                          borderRadius: '6px',
                          border: '1px solid #dc3545'
                        }}>
                          <strong style={{ color: '#721c24' }}>🔴 Kritik Bilgi:</strong>
                          <p style={{ margin: '8px 0 0', color: '#721c24', fontSize: '14px' }}>
                            Lisans süresi dolduğunda bu mesaj gönderilir. Eğer hesap süresi bitene kadar yenilenmezse ve durdurulursa/silinirse bu mesaj gönderilir. 
                            <strong> Önemli:</strong> Süresi bitene kadar hesap otomatik olarak dondurulmaz veya silinmez. Önce bu mesaj gönderilir ve bilgilendirme yapılır.
                          </p>
                        </div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                          0 Gün (Süresi Doldu) Mesajı
                        </label>
                        <textarea
                          value={settings.license_reminder_0_days || ''}
                          onChange={(e) => setSettings(prev => ({ ...prev, license_reminder_0_days: e.target.value }))}
                          rows={10}
                          style={{
                            width: '100%',
                            padding: '12px',
                            border: '2px solid #dc3545',
                            borderRadius: '6px',
                            boxSizing: 'border-box',
                            fontFamily: 'monospace',
                            fontSize: '13px',
                            lineHeight: '1.4'
                          }}
                          placeholder="Süresi dolduğunda gönderilecek mesaj..."
                        />
                        <small style={{ color: '#666', display: 'block', marginTop: '8px' }}>
                          <strong>Kullanılabilir değişkenler:</strong> {'{firma}'}, {'{kullanici-adi}'}, {'{baslama-tarihi}'}, {'{bitis-tarihi}'}
                        </small>
                      </div>
                    )}
                  </div>
                </div>

                <button
                  onClick={() => saveSettings('messages')}
                  disabled={loading}
                  style={{
                    padding: '12px 24px',
                    background: '#28a745',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    fontSize: '14px',
                    fontWeight: '600',
                    transition: 'all 0.3s'
                  }}
                  onMouseEnter={(e) => {
                    if (!loading) {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 8px rgba(40, 167, 69, 0.3)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  <i className="fas fa-save" style={{ marginRight: '8px' }}></i>
                  Sistem Mesajlarını Kaydet
                </button>
              </div>
            )}

            {/* Güvenlik Ayarları */}
            {activeSection === 'security' && (
              <div>
                <h2 style={{ marginTop: 0, marginBottom: '20px' }}>
                  <i className="fas fa-shield-alt" style={{ marginRight: '8px' }}></i>
                  Güvenlik Ayarları
                </h2>
                
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                    Oturum Zaman Aşımı (saniye)
                  </label>
                  <input
                    type="number"
                    value={settings.session_timeout}
                    onChange={(e) => setSettings(prev => ({ ...prev, session_timeout: parseInt(e.target.value) }))}
                    min="300"
                    max="86400"
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      boxSizing: 'border-box'
                    }}
                  />
                  <small style={{ color: '#666' }}>Kullanıcı oturumunun ne kadar süre sonra kapanacağı</small>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                    Maksimum Giriş Denemesi
                  </label>
                  <input
                    type="number"
                    value={settings.max_login_attempts}
                    onChange={(e) => setSettings(prev => ({ ...prev, max_login_attempts: parseInt(e.target.value) }))}
                    min="3"
                    max="10"
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      boxSizing: 'border-box'
                    }}
                  />
                  <small style={{ color: '#666' }}>Hesap kilitlenmeden önce kaç kez yanlış giriş yapılabileceği</small>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                    Minimum Şifre Uzunluğu
                  </label>
                  <input
                    type="number"
                    value={settings.password_min_length}
                    onChange={(e) => setSettings(prev => ({ ...prev, password_min_length: parseInt(e.target.value) }))}
                    min="4"
                    max="20"
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px',
                      boxSizing: 'border-box'
                    }}
                  />
                  <small style={{ color: '#666' }}>Kullanıcıların seçebileceği minimum şifre uzunluğu</small>
                </div>

                <button
                  onClick={() => saveSettings('security')}
                  disabled={loading}
                  style={{
                    padding: '12px 24px',
                    background: '#28a745',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    fontSize: '14px'
                  }}
                >
                  <i className="fas fa-save" style={{ marginRight: '8px' }}></i>
                  Güvenlik Ayarlarını Kaydet
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default SettingsPage;
